// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import * as assert from './assert';

// Returns whether given URL is absolute or not.
export function isAbsoluteUrl(url: string): boolean {
    return /^[a-z+]{3,16}:\/\//i.test(url);
}

// Appends hash parameter to a URL.
export function setHashParam(url: string, key: string, value: string): string {
    const urlObject = new URL(url);
    const hash = new URLSearchParams(urlObject.hash.substring(1));
    hash.set(key, value);
    urlObject.hash = hash.toString();
    return urlObject.toString();
}

// Combines a base URL and a relative URL.
export function combineUrls(baseUrl: string, relativeUrl: string): string {
    assert.isFalse(isAbsoluteUrl(relativeUrl), 'Relative URL must not be absolute.');
    baseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    relativeUrl = relativeUrl.startsWith('/') ? relativeUrl.substring(1) : relativeUrl;
    return `${baseUrl}${relativeUrl}`;
}
